import { useParams } from 'react-router';

import { useGetAboutBankQuery, useGetMainPageQuery } from '@/api/endpoints/mainPages';
import { FetchDataWrapper } from '@/shared/components';

import { transformDateToCorrectFormat } from '../helpers';

import { MainAboutBankPageComponent } from './MainAboutBankPageComponent';

export const MainAboutBankPage = () => {
  const { id } = useParams();
  const {
    data: pageData,
    isLoading: isPageLoading,
    isError: isPageDataFetchError,
  } = useGetMainPageQuery({ id: Number(id) });
  const {
    data: aboutBankData,
    isLoading: isAboutBankLoading,
    isError: isAboutBankFetchError,
  } = useGetAboutBankQuery({ id: Number(id) });

  return (
    <FetchDataWrapper
      isLoading={isPageLoading || isAboutBankLoading}
      isError={isAboutBankFetchError || isPageDataFetchError}
    >
      {pageData && aboutBankData && (
        <MainAboutBankPageComponent
          aboutBankData={aboutBankData}
          pageName={transformDateToCorrectFormat(pageData.created_at)}
          pageId={pageData.id}
        />
      )}
    </FetchDataWrapper>
  );
};
